import React, { Component } from 'react'
import Container from '@mui/material/Container'
import CssBaseline from '@mui/material/CssBaseline'
import Typography from '@mui/material/Typography'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import { Button } from '@mui/material'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'

// Components
import HeadGlobal from './headerGlobal'
// Utils
import {
  welcomeEs,
  welcomeFr,
  welcomeEn,
  welcomePtg,
} from '../textApp/textTrad'
import { checkUserQuotas } from '../data/saveSurvey'
import { navigationGA } from '../data/GA'

class Welcome extends Component {
  constructor(props) {
    super(props)

    this.state = {
      acceptRgpd: true,
      noAcceptRgpd: false,
      loaded: 0,
      modalOpen: false,
    }
    this.checkRgpd = this.checkRgpd.bind(this)
    this.clicked = this.clicked.bind(this)
    this.handleModal = this.handleModal.bind(this)
    this.clickedFinal = this.clickedFinal.bind(this)
  }

  static async getDerivedStateFromProps(nextProps, prevState) {
    const convertAge = (age) => {
      switch (true) {
        case age < 25 && !!age:
          return '18_24'
        case age > 24 && age < 35:
          return '25_34'
        case age > 34 && age < 50:
          return '35_49'
        case age > 49:
          return '50_65'
        default:
          return 'noAge'
      }
    }
    const {
      send2video,
      navigate,
      setlang,
      setSocDis,
      setCatego,
      setUserId,
      location,
    } = nextProps
    const paramsList = new URLSearchParams(location.search)
    const lng = paramsList.get('lng')
    const ctg = paramsList.get('ctg')
    const sd = paramsList.get('sd')
    const cntry = paramsList.get('cntry')
    const id = paramsList.get('ticket')
    const age = paramsList.get('ag')
    const gender = paramsList.get('sex')
    const rangeAge = convertAge(age)
    const user = JSON.parse(localStorage.getItem('dataUser'))
    if (!!id && !!lng && !!cntry) {
      const lang =
        lng === 'aa' ? 'en' : lng === 'bb' ? 'fr' : lng === 'cc' ? 'es' : 'pt'
      setlang(lang)
      setSocDis(sd)
      setCatego(ctg)
      setUserId(id)
      localStorage.setItem(
        'dataUser',
        JSON.stringify({
          ...user,
          gender: gender,
          cntry: cntry,
          id: id,
          catego: ctg,
          socDis: sd,
          lng: lang,
          age: age,
          rangeAge: rangeAge,
          loaded: (user || '').loaded ? user.loaded : 0,
          // existUser: true,
        })
      )
    } else {
      navigate('/noSurvey')
      localStorage.removeItem('dataUser')
    }
    if (send2video) {
      navigate('/video' + location.search)
    }
    return null
  }

  async componentDidMount() {
    const convertAge = (age) => {
      switch (true) {
        case age < 25 && !!age:
          return '18_24'
        case age > 24 && age < 35:
          return '25_34'
        case age > 34 && age < 50:
          return '35_49'
        case age > 49:
          return '50_65'
        default:
          return 'noAge'
      }
    }
    const { location, navigate, answers, setAns } = this.props
    const user = JSON.parse(localStorage.getItem('dataUser'))
    const paramsList = new URLSearchParams(location.search)
    const cntry = paramsList.get('cntry')
    const id = paramsList.get('ticket')
    const age = paramsList.get('ag')
    const gender = paramsList.get('sex')
    const rangeAge = convertAge(age)
    // Google Analitycs
    navigationGA('Home', 'welcome', 'welcome')
    // GETTING DATA FROM PARAMS

    if (user && id !== 'test') {
      // GETTING QUOTAS DATA
      // CHECKING IF USER EXIST IN DATABASE
      const id = paramsList.get('ticket')
      const quotas = await checkUserQuotas(id, rangeAge, gender, cntry)
      if (quotas[1] && !(user || '').catego) {
        navigate(
          '/home' + location.search + '&ctg=' + quotas[1] + '&sd=' + quotas[2]
        )
        setAns({ ...answers, rangeAge: rangeAge, gender: gender, cntry: cntry })
      }
      // USER EXIST REDIRECTION
      if (quotas[0]) {
        localStorage.setItem(
          'dataUser',
          JSON.stringify({ ...user, existUser: true })
        )
        // navigate('/noSurvey')
        // setTimeout(() => {
        //   window.location.replace(
        //     'https://transit.nicequest.com/transit/participation?tp=qf_1&c=ok&ticket=' +
        //       id
        //   )
        // }, 3000)
      }
    }
  }
  componentDidUpdate() {
    const { navigate, user, brand, location } = this.props
    const langs = ['aa', 'bb', 'cc', 'dd']
    const paramsList = new URLSearchParams(location.search)
    const lng = paramsList.get('lng')
    const isLang = !!lng && langs.filter((itm) => itm === lng).length > 0
    if (!isLang) {
      navigate('/noSurvey')
    }
    if (!!user && !!brand) {
      navigate('/video' + location.search)
    }
  }
  handleModal = () => {
    const { modalOpen } = this.state
    this.setState({
      modalOpen: !modalOpen,
    })
  }
  selectLang = () => {
    const { lng } = this.props
    switch (lng) {
      case 'es':
        return welcomeEs
      case 'fr':
        return welcomeFr
      case 'en':
        return welcomeEn
      case 'pt':
        return welcomePtg
      default:
        return welcomeEn
    }
  }

  checkRgpd = (data) => {
    const { setRgpd } = this.props
    if (data === 'yes') {
      this.setState({
        acceptRgpd: true,
        noAcceptRgpd: false,
      })
      setRgpd('acceptedRgpd')
    } else {
      this.setState({
        acceptRgpd: false,
        noAcceptRgpd: true,
      })
    }
  }
  clicked = () => {
    if (this.state.acceptRgpd) {
      const { navigate, location, setStart } = this.props
      const user = JSON.parse(localStorage.getItem('dataUser'))
      const paramsList = new URLSearchParams(location.search)
      const lng = paramsList.get('lng')
      const id = paramsList.get('ticket')
      if (!!id || !!lng) {
        const started = Date.now()
        setStart(started)
        localStorage.setItem(
          'dataUser',
          JSON.stringify({ ...user, started: started })
        )
        // navigate('/brand' + location.search)
      }
    } else {
      const txt = this.selectLang()
      // alert(txt.alertRgpd)
      this.handleModal()
    }
    this.handleModal()
  }
  clickedFinal = (e) => {
    const user = JSON.parse(localStorage.getItem('dataUser'))
    const { navigate, location, setStart } = this.props
    const paramsList = new URLSearchParams(location.search)
    const id = paramsList.get('ticket')
    const lng = paramsList.get('lng')
    if (e === 'yes') {
      this.setState({
        acceptRgpd: true,
      })
      if (!!id || !!lng) {
        const started = Date.now()
        setStart(started)
        localStorage.setItem(
          'dataUser',
          JSON.stringify({ ...user, started: started })
        )
        // navigate('/brand' + location.search)
      }
    }
    // else {
    //   window.location.replace(
    //     'https://transit.nicequest.com/transit/participation?tp=fo_0&c=ok&ticket=' +
    //       id
    //   )
    // }
  }
  redirect() {
    const { navigate, location } = this.props
    const langs = ['aa', 'bb', 'cc', 'dd']
    const paramsList = new URLSearchParams(location.search)
    const lng = paramsList.get('lng')
    const isLang = !!lng && langs.filter((itm) => itm === lng).length > 0
    if (!isLang) {
      navigate('/noSurvey')
    }
    return null
  }
  render() {
    const { setlang } = this.props
    const { acceptRgpd, noAcceptRgpd, modalOpen } = this.state
    // this.redirect()
    const txt = this.selectLang()
    const styleBoxMod = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 400,
      bgcolor: 'background.paper',
      border: '2px solid #000',
      boxShadow: 24,
      pt: 2,
      px: 4,
      pb: 3,
    }
    const styleModTxt = {
      fontSize: '1.2rem',
    }
    return (
      <div className='center'>
        <div className='main welcome'>
          <Modal open={modalOpen} onClose={this.handleModal}>
            <Box sx={{ ...styleBoxMod, width: '80vw' }}>
              <h2>
                <strong>{txt.noFolSurvey1}</strong>
              </h2>
              <div style={styleModTxt}>{txt.noFolSurvey2}</div>
              <div>
                {/* <Button
                  onClick={(_) => this.clickedFinal('yes')}
                  variant='contained'
                  color='success'
                  sx={{
                    marginRight: '2rem',
                    marginTop: '1vh',
                    padding: {
                      xs: '1rem 4rem',
                      sm: '1rem 2rem',
                      md: '1rem 2rem',
                    },
                    fontSize: {
                      xs: '1.3rem',
                      sm: '1.1rem',
                      md: '1.2rem',
                    },
                  }}
                >
                  {txt.noFolBotYes}
                </Button>
                <Button
                  onClick={(_) => this.clickedFinal('no')}
                  variant='contained'
                  color='error'
                  sx={{
                    marginTop: '1vh',
                    padding: {
                      xs: '1rem 4rem',
                      sm: '1rem 2rem',
                      md: '1rem 2rem',
                    },
                    marginRight: '1rem',
                    fontSize: {
                      xs: '1.3rem',
                      sm: '1.1rem',
                      md: '1.2rem',
                    },
                  }}
                >
                  {txt.noFolBotNot}
                </Button> */}
              </div>
            </Box>
          </Modal>
          <CssBaseline>
            <HeadGlobal setlang={setlang} changeLang={false} />
            <Typography
              component='h1'
              variant='h2'
              align='center'
              sx={{
                fontWeight: '700',
                paddingBottom: '2vh',
                fontSize: {
                  xs: '1.5rem',
                  sm: '1.5rem',
                  md: '2rem',
                },
              }}
            >
              {txt.titleIntro}
            </Typography>
            <Typography
              component='h1'
              variant='h4'
              align='center'
              sx={{
                fontWeight: '700',
                paddingBottom: '2vh',
                fontSize: {
                  xs: '1.5rem',
                  sm: '1.5rem',
                  md: '2rem',
                },
              }}
            >
              {txt.title}
            </Typography>
            <Typography
              component='h4'
              variant='h5'
              align='left'
              paddingBottom='1rem'
              sx={{
                fontSize: {
                  xs: '1.3rem',
                  sm: '1.4rem',
                  md: '1.5rem',
                },
              }}
            >
              {txt.inf1Par}
            </Typography>
            <Typography
              component='h4'
              variant='h5'
              align='left'
              paddingBottom='1rem'
              sx={{
                fontSize: {
                  xs: '1.3rem',
                  sm: '1.4rem',
                  md: '1.5rem',
                },
              }}
            >
              {txt.inf2Par}
            </Typography>
            {/* 
            //////////// GOAL INFORMATION 
            ///////// 
            */}
            <Typography
              component='h1'
              variant='h4'
              align='center'
              sx={{
                fontWeight: '700',
                paddingBottom: '2vh',
                fontSize: {
                  xs: '1.4rem',
                  sm: '1.4rem',
                  md: '1.6rem',
                },
              }}
            >
              {txt.goalTitle}
            </Typography>
            <Typography
              component='h4'
              variant='h5'
              align='left'
              paddingBottom='2rem'
              sx={{
                fontSize: {
                  xs: '1.3rem',
                  sm: '1.4rem',
                  md: '1.5rem',
                },
              }}
            >
              {txt.goalPar}
            </Typography>
            {/* 
            //////////// BOT DEFINITION 
            ///////// 
            */}
            <Typography
              component='h1'
              variant='h4'
              align='center'
              sx={{
                fontWeight: '700',
                paddingBottom: '2vh',
                fontSize: {
                  xs: '1.4rem',
                  sm: '1.4rem',
                  md: '1.6rem',
                },
              }}
            >
              {txt.botDefTitle}
            </Typography>
            <Typography
              component='h4'
              variant='h5'
              align='left'
              paddingBottom='2rem'
              sx={{
                fontSize: {
                  xs: '1.3rem',
                  sm: '1.4rem',
                  md: '1.5rem',
                },
              }}
            >
              {txt.botDefPar}
            </Typography>
            {/* 
            //////////// PARTICIPATION CRITERIA 
            ///////// 
            */}
            <Typography
              component='h1'
              variant='h4'
              align='center'
              sx={{
                fontWeight: '700',
                paddingBottom: '2vh',
                fontSize: {
                  xs: '1.4rem',
                  sm: '1.4rem',
                  md: '1.6rem',
                },
              }}
            >
              {txt.criterTitle}
            </Typography>
            <Typography
              component='h4'
              variant='h5'
              align='left'
              paddingBottom='2rem'
              sx={{
                fontSize: {
                  xs: '1.3rem',
                  sm: '1.4rem',
                  md: '1.5rem',
                },
              }}
            >
              {txt.criterPar}
            </Typography>
            {/* 
            //////////// MY QUESTION ABOUT AND PERSONAL DATA 
            ///////// 
            */}
            <Typography
              component='h1'
              variant='h4'
              align='center'
              sx={{
                fontWeight: '700',
                paddingBottom: '2vh',
                fontSize: {
                  xs: '1.4rem',
                  sm: '1.4rem',
                  md: '1.6rem',
                },
              }}
            >
              {txt.questAboutTitle}
            </Typography>
            <Typography
              component='h4'
              variant='h5'
              align='left'
              paddingBottom='2rem'
              sx={{
                fontSize: {
                  xs: '1.3rem',
                  sm: '1.4rem',
                  md: '1.5rem',
                },
              }}
            >
              {txt.questAbout1Par}
            </Typography>
            <Typography
              component='h4'
              variant='h5'
              align='left'
              paddingBottom='2rem'
              sx={{
                fontSize: {
                  xs: '1.3rem',
                  sm: '1.4rem',
                  md: '1.5rem',
                },
              }}
            >
              {txt.questAbout2Par}
            </Typography>
            <Typography
              component='h4'
              variant='h5'
              align='left'
              paddingBottom='2rem'
              sx={{
                fontSize: {
                  xs: '1.3rem',
                  sm: '1.4rem',
                  md: '1.5rem',
                },
              }}
            >
              {txt.questAbout3Par}
            </Typography>
            {/* 
            //////////// CONTACT INFORMATION 
            ///////// 
            */}
            <Typography
              component='h4'
              variant='h5'
              align='left'
              paddingBottom='2rem'
              sx={{
                fontSize: {
                  xs: '1.3rem',
                  sm: '1.4rem',
                  md: '1.5rem',
                },
              }}
            >
              <strong>{txt.contactTitle} </strong>
              {txt.contactPar}
            </Typography>
            {/* 
            //////////// QUESTION RGPD 
            ///////// 
            */}
            <Typography
              component='h2'
              variant='h4'
              align='center'
              sx={{
                fontWeight: '700',
                paddingBottom: '1vh',
                fontSize: {
                  xs: '1.3rem',
                  sm: '1.4rem',
                  md: '1.5rem',
                },
              }}
            >
              {txt.question}
            </Typography>
            <Container>
              <FormControlLabel
                sx={{
                  fontSize: '2rem',
                }}
                control={
                  <Checkbox
                    onClick={() => this.checkRgpd('yes')}
                    name='yesRgpd'
                    checked={acceptRgpd}
                    sx={{
                      '& .MuiSvgIcon-root': { fontSize: 30 },
                    }}
                  />
                }
                label={
                  <Typography
                    sx={{
                      fontSize: '1.5rem',
                      fontWeight: 'bold',
                    }}
                  >
                    {txt.yes}
                  </Typography>
                }
              />
              <FormControlLabel
                control={
                  <Checkbox
                    onClick={() => this.checkRgpd('no')}
                    name='noRgpd'
                    checked={noAcceptRgpd}
                    sx={{
                      '& .MuiSvgIcon-root': { fontSize: 30 },
                    }}
                  />
                }
                label={
                  <Typography sx={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
                    {txt.no}
                  </Typography>
                }
              />
            </Container>
            <Button
              onClick={this.clicked}
              variant='contained'
              sx={{
                marginTop: '2vh',
                padding: {
                  xs: '1rem 4rem',
                  sm: '1rem 2rem',
                  md: '1rem 2rem',
                },
                fontSize: {
                  xs: '1.2rem',
                  sm: '1.5rem',
                  md: '1.7rem',
                },
              }}
            >
              {txt.cont}
            </Button>
          </CssBaseline>
        </div>
      </div>
    )
  }
}

export default Welcome
